// extracted by mini-css-extract-plugin
export var contentBody = "_am-9";
export var headerImage = "_am-2";
export var imageButton = "_am-7";
export var imageButtonIcon = "_am-8";
export var imageHeader = "_am-4";
export var imageHeaderText = "_am-5";
export var imageOverlay = "_am-3";
export var imageTitle = "_am-6";
export var imageWrapper = "_am-1";
export var taskList = "_am-a";
export var widget = "_am-0";